/* Version: 3.5.155 */
'use client';
import styled from 'styled-components';
import Icon from '../Icon/Icon.js';
import { FocusOutlineInset } from '../../mixins/index.js';
import { rem } from '../../utils/functions.js';
import { MESSAGE_VARIANT } from './constants.js';
import { typography } from '../../typography/typography.js';

var MessageCardWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__MessageCardWrapper",
  componentId: "sc-1ia1h22-0"
})(["font-family:", ";border:", ";border-left:0px;color:", ";font-size:", ";font-weight:300;line-height:", ";background-color:", ";padding:", ";position:relative;display:", ";"], typography.fontFamily, function (_ref) {
  var variant = _ref.variant,
    theme = _ref.theme;
  var borderStyle = '';
  switch (variant) {
    case MESSAGE_VARIANT.PRIMARY_WARNING:
      borderStyle = "2px solid ".concat(theme.colorPalette.utilityColors.warning);
      break;
    case MESSAGE_VARIANT.PRIMARY_ALERT:
      borderStyle = "2px solid ".concat(theme.colorPalette.utilityColors.alert);
      break;
    case MESSAGE_VARIANT.PRIMARY_COMPLETE:
      borderStyle = "2px solid ".concat(theme.colorPalette.utilityColors.complete);
      break;
    case MESSAGE_VARIANT.SECONDARY_INFORMATION:
    case MESSAGE_VARIANT.SECONDARY_WARNING:
    case MESSAGE_VARIANT.SECONDARY_ALERT:
    case MESSAGE_VARIANT.SECONDARY_COMPLETE:
    case MESSAGE_VARIANT.HARDSTOP:
      borderStyle = 'none';
      break;
    default:
      borderStyle = "2px solid ".concat(theme.colorPalette.utilityColors.info);
  }
  return borderStyle;
}, function (_ref2) {
  var variant = _ref2.variant,
    theme = _ref2.theme;
  return variant === MESSAGE_VARIANT.HARDSTOP ? theme.colorPalette.neutralColors.light.shade_white : theme.colorPalette.neutralColors.dark.shade_light_1;
}, typography.fontSize, typography.lineHeight, function (_ref3) {
  var variant = _ref3.variant,
    theme = _ref3.theme;
  var backgroundStyle = '';
  switch (variant) {
    case MESSAGE_VARIANT.SECONDARY_INFORMATION:
    case MESSAGE_VARIANT.SECONDARY_WARNING:
    case MESSAGE_VARIANT.SECONDARY_ALERT:
    case MESSAGE_VARIANT.SECONDARY_COMPLETE:
      backgroundStyle = 'transparent';
      break;
    case MESSAGE_VARIANT.HARDSTOP:
      backgroundStyle = theme.colorPalette.utilityColors.alert;
      break;
    default:
      backgroundStyle = theme.colorPalette.neutralColors.light.shade_white;
  }
  return backgroundStyle;
}, function (_ref4) {
  var variant = _ref4.variant,
    hasCloseButton = _ref4.hasCloseButton;
  var rightPadding = '30px';
  if (hasCloseButton) {
    rightPadding = '40px';
  }
  var paddingStyle = "18px ".concat(rightPadding, " 18px 60px");
  switch (variant) {
    case MESSAGE_VARIANT.SECONDARY_INFORMATION:
    case MESSAGE_VARIANT.SECONDARY_WARNING:
    case MESSAGE_VARIANT.SECONDARY_ALERT:
    case MESSAGE_VARIANT.SECONDARY_COMPLETE:
      paddingStyle = "20px ".concat(rightPadding, " 20px 45px");
      break;
  }
  return paddingStyle;
}, function (_ref5) {
  var isOpen = _ref5.isOpen;
  return isOpen ? 'block' : 'none';
});
process.env.NODE_ENV !== "production" ? MessageCardWrapper.displayName = 'MessageCardWrapper' : undefined;
var IconBar = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__IconBar",
  componentId: "sc-1ia1h22-1"
})(["font-family:", ";position:absolute;top:0;left:0;bottom:0;width:", ";background-color:", ";color:", ";text-align:center;padding-top:20px;font-weight:bold;font-size:", ";"], typography.fontFamily, function (_ref6) {
  var variant = _ref6.variant;
  return variant === MESSAGE_VARIANT.HARDSTOP ? '60px' : '40px';
}, function (_ref7) {
  var variant = _ref7.variant,
    theme = _ref7.theme;
  var backgroundStyle = '';
  switch (variant) {
    case MESSAGE_VARIANT.PRIMARY_WARNING:
      backgroundStyle = theme.colorPalette.utilityColors.warning;
      break;
    case MESSAGE_VARIANT.PRIMARY_ALERT:
      backgroundStyle = theme.colorPalette.utilityColors.alert;
      break;
    case MESSAGE_VARIANT.PRIMARY_COMPLETE:
      backgroundStyle = theme.colorPalette.utilityColors.complete;
      break;
    case MESSAGE_VARIANT.HARDSTOP:
      backgroundStyle = theme.colorPalette.utilityColors.alert;
      break;
    default:
      backgroundStyle = theme.colorPalette.utilityColors.info;
  }
  return backgroundStyle;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, rem(22));
process.env.NODE_ENV !== "production" ? IconBar.displayName = 'IconBar' : undefined;
var IconCircle = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__IconCircle",
  componentId: "sc-1ia1h22-2"
})(["font-family:", ";position:absolute;top:15px;left:", ";width:32px;height:32px;line-height:", ";border-radius:16px;background-color:", ";color:", ";text-align:center;font-weight:bold;font-size:", ";.material-icons{line-height:", ";}"], typography.fontFamily, function (_ref9) {
  var variant = _ref9.variant;
  var leftStyle = '15px';
  switch (variant) {
    case MESSAGE_VARIANT.SECONDARY_INFORMATION:
    case MESSAGE_VARIANT.SECONDARY_WARNING:
    case MESSAGE_VARIANT.SECONDARY_ALERT:
    case MESSAGE_VARIANT.SECONDARY_COMPLETE:
      leftStyle = '0';
      break;
  }
  return leftStyle;
}, rem(32), function (_ref10) {
  var variant = _ref10.variant,
    theme = _ref10.theme;
  var backgroundStyle = '';
  switch (variant) {
    case MESSAGE_VARIANT.SECONDARY_WARNING:
      backgroundStyle = theme.colorPalette.utilityColors.warning;
      break;
    case MESSAGE_VARIANT.SECONDARY_ALERT:
      backgroundStyle = theme.colorPalette.utilityColors.alert;
      break;
    case MESSAGE_VARIANT.SECONDARY_COMPLETE:
      backgroundStyle = theme.colorPalette.utilityColors.complete;
      break;
    default:
      backgroundStyle = theme.colorPalette.utilityColors.info;
  }
  return backgroundStyle;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, rem(22), rem(32));
process.env.NODE_ENV !== "production" ? IconCircle.displayName = 'IconCircle' : undefined;
var SecondaryIcon = /*#__PURE__*/styled(Icon).withConfig({
  displayName: "styledComponents__SecondaryIcon",
  componentId: "sc-1ia1h22-3"
})(["display:flex;align-items:center;justify-content:center;height:100%;"]);
process.env.NODE_ENV !== "production" ? SecondaryIcon.displayName = 'Icon' : undefined;
var CloseButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__CloseButton",
  componentId: "sc-1ia1h22-4"
})(["position:absolute;top:8px;right:8px;width:24px;height:24px;background:none;border:none;padding:0;margin:0;cursor:pointer;&:focus-visible{", ";}"], FocusOutlineInset);
process.env.NODE_ENV !== "production" ? CloseButton.displayName = 'CloseButton' : undefined;
var MessageTitle = /*#__PURE__*/styled.strong.withConfig({
  displayName: "styledComponents__MessageTitle",
  componentId: "sc-1ia1h22-5"
})(["font-weight:600;"]);
process.env.NODE_ENV !== "production" ? MessageTitle.displayName = 'MessageTitle' : undefined;

export { CloseButton, IconBar, IconCircle, MessageCardWrapper, MessageTitle, SecondaryIcon };
